import { makeStyles } from "@material-ui/core/styles";
import * as colors from "../../../../theme/colors";
import ButtonArrowLeft from "@/images/arrow-left.svg";

const useStyles = makeStyles(() => ({

  item: {
    fontFamily: "Roboto",
    width: "100%",
    display: "flex",
    backgroundColor: colors.ideGrey200,
    padding: '24px 32px',
    gap: 8,
    borderTopLeftRadius: 12,
    borderBottomLeftRadius: 12,
    marginBottom: 8,
    justifyContent: "center",
    cursor: "pointer",
    fontWeight: 500,
    fontSize: 16,
    lineHeight: "24px",
    color: colors.ideGreen800,
    position: "relative",
  },

  itemActive: {
    background: colors.ideLinear1Gradient,
    paddingRight: 38,
    fontWeight: 700,
    color: colors.darkBlue900,

    "&::after": {
      content: '""',
      backgroundImage: `url("${ButtonArrowLeft}")`,
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      position: "absolute",
      right: -15,
      height: 39,
      width: 39,
      top: 17,
    },
  },

  buttonIcon: {
    width: 24,
    height: 24,
  },

}));

export { useStyles };
